import { CANVAS_LEFT_MARGIN, CANVAS_WIDTH } from '@constants/canvas/general';
import { Typography } from '@mui/material';
import { themePalette } from '@theme/muiTheme';
import styled from 'styled-components';

export const LayerNodeStyled = styled('div')<{
  $small?: boolean;
  $height?: string;
  $stripeWidth: number;
}>`
  position: relative;
  left: -${CANVAS_LEFT_MARGIN}px;
  width: ${CANVAS_WIDTH}px;
  height: ${(p) => {
    if (p.$height) return p.$height;
    return p.$small ? '168px' : '264px';
  }};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px 0 0 24px;
  background: transparent;
    
  &::after {
      content: '';
      border-bottom: 1px solid ${themePalette.grey[600]};
      width: ${({ $stripeWidth }) => `${$stripeWidth}px`};
      position: fixed;
      bottom: 0;
      left: -${CANVAS_LEFT_MARGIN}px;
  }
}
`;

export const StyledText = styled(Typography)<{ collapsed: boolean }>`
  color: ${({ collapsed }) =>
    `${themePalette.grey[collapsed ? 700 : 1000]} !important`};
`;
